import Color from 'color';

export const Settings = Object.freeze({
  UPDATE_SETTING: 'UPDATE_SETTING',
  UPDATE_SETTING_FOR_GROUP: 'UPDATE_SETTING_FOR_GROUP',
});

export const Theme = Object.freeze({
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  CUSTOM: 'CUSTOM',
});

export const updateSettings = (settings) => {
  const allKeys = Object.keys(INIT_STATE);
  const payload = {};
  for (const [key, value] of Object.entries(settings)) {
    if (allKeys.includes(key)) {
      payload[key] = value;
    }
  }
  return {
    type: Settings.UPDATE_SETTING,
    payload,
  };
};

export const updateSettingsForGroup = (group, settings) => {
  if (!group) {
    return;
  }
  const allKeys = Object.keys(INIT_STATE[group]);
  const payload = {};
  for (const [key, value] of Object.entries(settings)) {
    if (key === 'color') {
      if (!settings.customColor) {
        payload.customColor = value;
      }
    } else if (key === 'bgColor') {
      if (!settings.customBgColor) {
        payload.customBgColor = value;
      }
    } else if (allKeys.includes(key)) {
      payload[key] = value;
    }
  }
  return {
    type: Settings.UPDATE_SETTING_FOR_GROUP,
    group,
    payload,
  };
};

export const resetDefaultFont = (group) => ({
  type: Settings.UPDATE_SETTING_FOR_GROUP,
  group,
  payload: {
    font: INIT_STATE.font,
    fontSize: INIT_STATE.fontSize,
  },
});

export const resetDefaultColors = (group) => ({
  type: Settings.UPDATE_SETTING_FOR_GROUP,
  group,
  payload: {
    theme: INIT_STATE.theme,
    color: INIT_STATE.color,
    bgColor: INIT_STATE.bgColor,
  },
});

const getTextColor = (settings) => {
  const { theme, customColor = 'black' } = settings;
  switch (theme) {
    case Theme.LIGHT:
      return 'black';
    case Theme.DARK:
      return 'white';
    case Theme.CUSTOM:
      return customColor;
  }
};

const getBgColor = (settings) => {
  const { theme, customBgColor = 'white' } = settings;
  switch (theme) {
    case Theme.LIGHT:
      return 'white';
    case Theme.DARK:
      return 'primary';
    case Theme.CUSTOM:
      return customBgColor;
  }
};

const getAltBgColor = (settings) => {
  const { theme, customBgColor = 'white' } = settings;
  switch (theme) {
    case Theme.LIGHT:
      return 'brand.100';
    case Theme.DARK:
      return 'black';
    case Theme.CUSTOM:
      try {
        return Color(customBgColor).darken(0.2).hex();
      } catch (err) {
        return customBgColor;
      }
  }
};

export const getSettingsForGroup = (group) => (state) => {
  const settings = state.settings[group] || {};
  return {
    ...settings,
    color: getTextColor(settings),
    bgColor: getBgColor(settings),
    altBg: getAltBgColor(settings),
  };
};

export const getSettingsForChat = (state) => {
  return getSettingsForGroup('chat')(state);
};

export const getSettingsForInterpretation = (state) => {
  return getSettingsForGroup('interpretation')(state);
};

const INIT_STATE = {
  chat: {
    font: 'avenir',
    fontSize: 16,
    theme: Theme.DARK,
    customColor: null,
    customBgColor: null,
  },
  interpretation: {
    font: 'avenir',
    fontSize: 16,
    theme: Theme.DARK,
    customColor: null,
    customBgColor: null,
  },
  volume: 1.0,
  cameraInUse: true,
  micInUse: true,
};

export const settingsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case Settings.UPDATE_SETTING: {
      return { ...state, ...action.payload };
    }
    case Settings.UPDATE_SETTING_FOR_GROUP: {
      const { group } = action;
      return { ...state, [group]: { ...state[group], ...action.payload } };
    }
    default:
      return state;
  }
};
